
import { _get, _post } from "./index2";
import axios2 from "./index2";
// 获得短信验证码
export const mail_code = (data: any) => {
  const req = {
    method: "get",
    url: `common/sms/${data.verificationEnums}/${data.mobile}`,
  };
  // @ts-ignore
  return axios2(req);
};

// 获取信息类政策(全部)
//头部地址接口
export const data_fold = () => {
  const req = {
    url: "home/allCity",
  };
  return _get(req);
};
// 获取所有的省-市(已有政策的数据)
export const allCityNum = () => {
  const req = {
    url: "home/allCityNum",
  };
  return _get(req);
};
export const getAddress = () => {
  const req = {
    url: "home/getLocationCity",

  };
  return _get(req);
};
//获取子地区
export const getAddressItem = (id: any) => {
  const req = {
    url: "common/region/item/" + id,
  };
  return _get(req);
};
//通过id获取子地区(已有政策数据)
export const getAddressItemNum = (id: any) => {
  const req = {
    url: "common/region/itemNum/" + id,
  };
  return _get(req);
};
//获取部门
export const getDept = (id: any) => {
  const req = {
    url: "common/department/addressId/" + id,
  };
  return _get(req);
};
//根据地址ID获取部门信息（已有政策数据）
export const getDeptNumber = (id: any) => {
  const req = {
    // url: "common/department/addressIdNum/" + id,
	 url: "home/addressIdNum/" + id,
  };
  return _get(req);
};
export const clearAddresStorage = () => {
  const req = {
    url: "zst/address/AllAddressAndDepartment",
  };
  return _get(req);
};
// 获得解密
export const decrypt = (url: any) => {
  const req = {
    url: `zst/user/common/getBs64ToDecrypt?url=${encodeURIComponent(url)}`,
  };
  return _get(req);
};
// 获取热门城市
export const hot_city = () => {
  const req = {
    url: "zst/user/address/popularCities",
  };
  return _get(req);
};
// 添加热门城市
export const addPopularCitiy = (data: any) => {
  if (data.name === "北京") {
    return new Promise((resolve, reject): any => {
      resolve({ code: 0, data: true, msg: "" });
    });
  }
  const req = {
    data,
    url: "zst/user/address/addPopularCities",
  };
  return _post(req);
};
// 获得单个企业信息详情
export const search_company_data = (parameter: any) => {
  // const req = {
  //   data: { parameter },
  //   url: 'zst/user/search/getCorporateInfo',
  // };
  const req = {
    data: { parameter },
    url: "zst/zstapi/user/common/getCorporateInfo",
  };

  return _get(req);
};
// 获取搜索框补全数据
export const policy_search_list = (data: any) => {
  // const req = {
  //   data,
  //   url: 'zst/user/common/corporateNameCompletion',
  // };
  const req = {
    data,
    url: "zstapi/user/company/corporateNameCompletion",
  };
  return _get(req);
};
// 上传文件
export const uploadFile = (data: any) => {
  const req = {
    data,
    url: "zst/user/file/uploadingFile",
  };
  return _post(req);
};
// 上传文件oss
export const uploadFileOss = (data: any) => {
  const req = {
    data,
    url: "zst/user/file/upload-oss",
  };
  return _post(req);
};
// 获取性质
export const nature = () => {
  const req = {
    url: "home/getNature",
  };
  return _get(req);
};
// 获取base64图片
export const getImage = ({ pathUrl }: any) => {
  const data = {
    pathUrl: pathUrl,
  };
  const req = {
    data,
    url: "zst/user/file/getPathToByte",
  };

  return _get(req);
};
export const getImgScream = (data: any) => {
  const req = {
    data,
    url: "zst/user/common/getPathToByte",
  };

  return _get(req);
};
export const download = (data: any) => {
  const req = {
    data,
    url: "zst/user/file/downloadFile",
  };

  return _get(req);
};
export const batchDownload = (data: any) => {
  const req = {
    data,
    url: "zst/user/file/batchDownload",
  };

  return _get(req);
};
//诉求目的
export const dicItem = (type: any) => {
  const req = {
    url: "/home/sysDicItemList?dicName=" + type,
  };
  return _get(req);
};
// 获取所有的省-市-区
export const allDistrict = () => {
  const req = {
    url: "home/allDistrict",
  };
  return _get(req);
};
